import BaseModel from "./_BaseModel";
import Satuan from "./Satuan";
import KategoriBrg from "./KategoriBrg";
import GroupBrg from "./GroupBrg";

export default class Barang extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public nama?: string;
	public kode_lain?: string;
	public nama_lain?: string;
    public is_non_stok?: boolean = false;
	public keterangan?: string;
    public aktif?: boolean = true;
    public ucode_satuan?: string;	
	public posisi?: Satuan;
    public list_kategori_brg?: KategoriBrg[] = [];
    public list_group_brg?: GroupBrg[] = [];
    public is_new?: boolean = false;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}
